interface Props {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  dataLength: number; // Either "array.length" or "Object.keys(data).length"
  emptyDataComponent?: React.ReactNode;
  loadingComponent?: React.ReactNode;
  errorComponent?: React.ReactNode;
  dataComponent?: React.ReactNode;
  shouldStartEmpty?: boolean; // For scenarios where it should render the empty component first without isSuccess being true
}
export const renderLoadingErrorData = ({
  isLoading,
  isError,
  isSuccess,
  dataLength,
  emptyDataComponent,
  loadingComponent,
  errorComponent,
  dataComponent,
  shouldStartEmpty,
}: Props) => {
  if (isError) {
    // import.meta.env.DEV && console.log("[DEV] in error state");
    // else if (isError && !dataLength) {
    return errorComponent;
    // } else if (isLoading && !dataLength) {
  } else if (isLoading) {
    // import.meta.env.DEV && console.log("[DEV] in loading state");
    return loadingComponent;
  } else if ((isSuccess && !dataLength) || (!isSuccess && shouldStartEmpty)) {
    // import.meta.env.DEV && console.log("[DEV] in empty state");
    return emptyDataComponent;
  } else {
    // import.meta.env.DEV && console.log("[DEV] in data state");
    return dataComponent;
  }
};
